import i18n from '@shared/services/i18n/i18n';
import { type FC, type PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

export const I18nProvider: FC<PropsWithChildren> = ({ children }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);
